import { buildOption } from '@/core/components/BoxSelector';

export default class ThemeSettingsController {
  /* @ngInject */
  constructor($async, Authentication, ThemeManager, StateManager, UserService, Notifications) {
    this.$async = $async;
    this.Authentication = Authentication;
    this.ThemeManager = ThemeManager;
    this.StateManager = StateManager;
    this.UserService = UserService;
    this.Notifications = Notifications;

    this.setTheme = this.setTheme.bind(this);
  }

  /** Theme Settings Panel */
  async updateTheme() {
    try {
      await this.UserService.updateUserTheme(this.state.userId, this.state.userTheme);
      this.state.themeInProgress = false;
      this.Notifications.success('Готово', 'Тема оформления обновлена');
    } catch (err) {
      this.Notifications.error('Ошибка', err, 'Не удалось обновить тему оформления');
    }
  }

  setTheme(theme) {
    if (theme === 'auto' || !theme) {
      this.ThemeManager.autoTheme();
    } else {
      this.ThemeManager.setTheme(theme);
    }
    this.state.themeInProgress = true;
    this.state.userTheme = theme;
  }

  $onInit() {
    return this.$async(async () => {
      this.state = {
        userId: null,
        userTheme: '',
        initTheme: '',
        defaultTheme: 'auto',
        themeInProgress: false,
      };

      this.state.availableThemes = [
        buildOption('light', 'fas fa-sun', 'Светлая тема', 'Оформление по умолчанию', 'light'),
        buildOption('dark', 'fas fa-moon', 'Тёмная тема', 'Тёмное оформление', 'dark'),
        buildOption('highcontrast', 'fas fa-adjust', 'Контрастная тема', 'Оформление с повышенной контрастностью', 'highcontrast'),
        buildOption('auto', 'fas fa-sync-alt', 'Как в системе', 'Использовать тему операционной системы', 'auto'),
      ];

      try {
        this.state.userId = await this.Authentication.getUserDetails().ID;
        const data = await this.UserService.user(this.state.userId);
        this.state.userTheme = data.UserTheme || this.state.defaultTheme;
        this.state.initTheme = this.state.userTheme;
      } catch (err) {
        this.Notifications.error('Ошибка', err, 'Не удалось получить сведения о пользователе');
      }
    });
  }

  $onDestroy() {
    if (this.state.themeInProgress) {
      this.ThemeManager.setTheme(this.state.initTheme);
    }
  }
}
